import { render } from "./bidWarning.vue?vue&type=template&id=350da821"
import script from "./bidWarning.vue?vue&type=script&lang=js"
export * from "./bidWarning.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__